module.exports = __webpack_public_path__ + "img/img-i5gam-tab4-2.56b2722f.png";